import { SenecButtonSize, SenecButtonLevel, SenecButtonColorTheme } from "src/components/button/ButtonUtils";
import { LinkProps, TypographyOwnProps, IconButton, IconButtonProps } from "@mui/material";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { styled } from "src/styles/fpp-theme/fppStyled";
import { functionalButtonStyles } from "src/components/button/senec-functional-button/SenecFunctionalButton";

const functionalIconButtonWidthSmall = "32px";
const functionalIconButtonWidthMedium = "40px";

export interface SenecFunctionalIconButtonProps
    extends Omit<IconButtonProps, "color" | "size">,
        Omit<LinkProps, keyof TypographyOwnProps | keyof IconButtonProps> {
    level?: SenecButtonLevel;
    size?: SenecButtonSize;
    colorTheme?: SenecButtonColorTheme;
}

export const SenecFunctionalIconButton = ({
    level = "primary",
    size = "medium",
    colorTheme = "light",
    ...rest
}: SenecFunctionalIconButtonProps) => {
    return <StyledFunctionalIconButton {...rest} level={level} size={size} colorTheme={colorTheme} />;
};

interface StyledFunctionalIconButtonProps
    extends IconButtonProps,
        Omit<LinkProps, keyof TypographyOwnProps | keyof IconButtonProps> {
    level: SenecButtonLevel;
    size: SenecButtonSize;
    colorTheme: SenecButtonColorTheme;
}

const StyledFunctionalIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "colorTheme",
})<StyledFunctionalIconButtonProps>(
    ({
        theme,
        level,
        size,
        colorTheme,
    }: {
        theme: SenecFPPTheme;
        level: SenecButtonLevel;
        size: SenecButtonSize;
        colorTheme: SenecButtonColorTheme;
    }) => ({
        ...functionalButtonStyles(theme, level, size, colorTheme),
        padding: "0px",
        width: functionalIconButtonWidthMedium,
        ...(size === "small" && {
            width: functionalIconButtonWidthSmall,
        }),
    }),
);
